<script setup lang="ts">
import IconRocket from '@/components/icons/IconRocket.vue';

defineProps({
  withBackground: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>

<template>
  <div
    class="upgrade-icon"
    :class="{ 'upgrade-icon--with-background': withBackground }">
    <IconRocket />
  </div>
</template>

<style scoped>
.upgrade-icon {
  --background: var(--color-primary);
  --color: var(--color-primary-contrast);
  --size: 2rem;

  color: var(--color);
  border-radius: 50%;
  width: var(--size);
  height: var(--size);

  &.upgrade-icon--with-background {
    padding: var(--space-2);
    background: var(--background);
  }

  svg {
    transform: rotate(45deg);
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
